import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestInterest1stEnum as InterestEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  INTEREST_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleRankingList } from "../DiagnosisInvestmentStyleRankingList";

import { useStepStyles } from "./stepStyles";

type InterestStepProps = {
  interest: InterestEnum[];
  onInterestChange: (next: InterestEnum[]) => void;
};

const InterestStep: React.FC<InterestStepProps> = ({ interest, onInterestChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>不動産投資で大切にしたいこと</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[3]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleRankingList
          options={INTEREST_OPTIONS}
          ranked={interest}
          max={3}
          onChange={onInterestChange}
        />
      </Box>
    </>
  );
};

export default InterestStep;
